export default "__VITE_ASSET__BgjEeLRP__"